import React from 'react';
import { Box, Flex, Text } from '@chakra-ui/react';
import AleaCloseIcon from '../../icons/AleaCloseIcon';

interface AleaSelectedTagProps {
  label: string;
  onRemove: () => void;
}

const AleaSelectedTag: React.FC<AleaSelectedTagProps> = ({ label, onRemove }) => {
  return (
    <Flex
      alignItems="center"
      justifyContent="space-between"
      bg="white"
      borderRadius="full"
      py="0px"
      px="12px"
      mr="8px"
      mb="8px"
      height="30px"
    >
      <Text fontSize="15px" fontWeight="300" mr="8px">
        {label}
      </Text>
      <Box 
        as="button" 
        onClick={onRemove}
        display="flex"
        alignItems="center"
        justifyContent="center"
        borderRadius="full"
        p="2px"
        _hover={{ 
          bg: "#f5f5f5" 
        }}
      >
        <AleaCloseIcon color="#EF5C36" size="16" />
      </Box>
    </Flex>
  );
};

export default AleaSelectedTag; 